// Image assets exports
// Import and export your images here for easier importing

import TrustJetPlaneImage from './backgrounds/bgplaceholdernew.jpg';

// Logos
// export { default as TrustJetLogo } from './logos/trustjet-logo.png';
// export { default as TrustJetLogoWhite } from './logos/trustjet-logo-white.png';

// Backgrounds
// export { default as AirplaneBackground } from './backgrounds/airplane-sky.jpg';
// export { default as LoginBackground } from './backgrounds/login-bg.jpg';

// Icons
// export { default as PlaneIcon } from './icons/plane.svg';

// Avatars
// export { default as DefaultAvatar } from './avatars/default-avatar.png';

// Usage example:
// import { TrustJetLogo, AirplaneBackground } from '../assets/images';

export { default as TrustJetLogoWhite } from './logos/logo_white.svg';
export { default as TrustJetLogoBlack } from './logos/logo_black.svg';
export { default as TrustJetLogoWhiteSlunt } from './logos/whitelogoslunt.png';
export { default as TrustJetBackground } from './backgrounds/bgsky2.jpg';
export { default as TrustJetLogoColored } from './logos/logoblack.png';
export const TrustJetPlane = TrustJetPlaneImage;
export { default as TrustJetLogoV2 } from './logos/logov2.png';
export { default as TrustJetBrandLogo } from './logos/brand_logos.png';
export { default as EmptyState } from './logos/empty_state.svg';

// Aircraft images - dynamically imported by filename using webpack's require.context
// Usage: const image = aircraftImages['BD-700-1A10'] or getAircraftImage('BD-700-1A10')
const aircraftContext = require.context('./aircraft', false, /\.(jpg|png)$/);

export const aircraftImages = Object.fromEntries(
  aircraftContext.keys().map((path) => {
    // Extract filename without extension: './BD-700-1A10.jpg' -> 'BD-700-1A10'
    const filename = path.replace('./', '').replace(/\.(jpg|png)$/, '');
    return [filename, aircraftContext(path)];
  })
);

// Aircraft carousel images - loads all images from subdirectories
// e.g. ./aircraft/BD-100-1A10/*.jpg -> aircraftCarouselImages['BD-100-1A10'] = [img1, img2, ...]
const aircraftDirContext = require.context('./aircraft', true, /\/[^/]+\/[^/]+\.(jpg|png)$/);

export const aircraftCarouselImages = {};
aircraftDirContext.keys().forEach((path) => {
  // path format: './BD-100-1A10/image.jpg'
  const parts = path.replace('./', '').split('/');
  const dirName = parts[0];
  if (!aircraftCarouselImages[dirName]) {
    aircraftCarouselImages[dirName] = [];
  }
  aircraftCarouselImages[dirName].push(aircraftDirContext(path));
});

// Helper function to get aircraft image by model name
// If model is a directory, returns the first image from that directory
export const getAircraftImage = (modelName) => {
  if (aircraftImages[modelName]) return aircraftImages[modelName];
  const dirImages = aircraftCarouselImages[modelName];
  if (dirImages && dirImages.length > 0) return dirImages[0];
  return TrustJetPlaneImage;
};

// Helper function to get all carousel images for an aircraft model
// If model is a directory, returns all images; if a single file, wraps it in an array
export const getAircraftCarouselImages = (modelName) => {
  const dirImages = aircraftCarouselImages[modelName];
  if (dirImages && dirImages.length > 0) return dirImages;
  const single = aircraftImages[modelName];
  return single ? [single] : [TrustJetPlaneImage];
};

